import { useMemo, useState } from "react";
import { comics } from "@/mocks/comics";

const filters = ["全部", "玄幻", "恋爱", "末世", "科幻", "悬疑", "校园"];

const statusColor: Record<string, string> = {
  连载中: "bg-accent-100 text-accent-800",
  已完结: "bg-secondary-100 text-secondary-800",
};

export default function UpdatesSection() {
  const [active, setActive] = useState("全部");

  const list = useMemo(
    () => (active === "全部" ? comics : comics.filter((c) => c.genre === active)),
    [active],
  );

  return (
    <section id="updates" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 text-primary-700 px-3 py-1 text-xs">
              <i className="ri-fire-line"></i>今日上新
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">今日更新</h2>
            <p className="mt-2 text-sm text-foreground-600">每天定时整理全站连载同步，最新话优先置顶</p>
          </div>
          <p className="text-xs text-foreground-500">更新时间：今天 09:20 · 共 86 部作品上新</p>
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-2">
          {filters.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setActive(f)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors cursor-pointer ${
                active === f
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {list.map((comic) => (
            <article
              key={comic.id}
              className="group rounded-lg overflow-hidden border border-background-200 bg-background-100 hover:border-primary-300 transition-colors"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden">
                <img
                  src={comic.cover}
                  alt={`${comic.title}韩漫最新章节`}
                  className="w-full h-full object-top object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-2 left-2 rounded-md bg-foreground-950/70 text-white text-xs px-2 py-1">
                  {comic.status}
                </span>
                <span className="absolute top-2 right-2 w-8 h-8 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xs font-bold">
                  {comic.id}
                </span>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/80 to-transparent px-3 py-2">
                  <span className="text-xs text-white">{comic.latestChapter}</span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-medium text-sm md:text-base text-foreground-950 truncate">{comic.title}</h3>
                <div className="mt-2 flex items-center justify-between">
                  <span className="text-xs text-foreground-600">{comic.genre} · {comic.author}</span>
                  <span className="text-xs text-accent-700 font-medium">{comic.updateTime}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}